import { SectionTypeConfig } from '@betterfunnel/types';
import { collection, getDocs, query, where } from 'firebase/firestore';
import { db } from '../Firebase';
import { emptyConverter } from '../utils';

export const sectionTypesColRef = () => {
  return collection(db, 'sectionTypes').withConverter(
    emptyConverter<SectionTypeConfig>(),
  );
};

export const getAccountSectionTypes = async (accountId: string) => {
  return getDocs(
    query(sectionTypesColRef(), where('accountId', 'in', [accountId, ''])),
  );
};
